/* eslint-disable @typescript-eslint/dot-notation */
import { memo } from 'react';
import Icons from '../../../configs/icon.config';

interface MobileMenuItemProps {
  notificationBubble?: boolean;
  icon: string;
  onClick?: (title: string | undefined) => void;
  title?: string;
}

function MobileMenuItem({
  notificationBubble,
  icon,
  onClick,
  title,
}: MobileMenuItemProps) {
  return (
    <li className="mobile-menu-item">
      <button
        onClick={() => onClick?.(title)}
        className="mobile-menu-item relative"
        style={{ color: '#d10d74' }}
      >
        {notificationBubble && (
          <span className="top-[-5px] left-[45px] absolute w-5 h-5 bg-[#12BCE6] border-2 border-white dark:border-gray-800 rounded-full" />
        )}
        <div className="text-4xl mb-2">{Icons[icon]}</div>
        <div className="text-2xl font-bold">{title}</div>
      </button>
    </li>
  );
}

export default memo(MobileMenuItem);
